import { render, staticRenderFns } from "./CHeaderImg.vue?vue&type=template&id=6965eb42&"
import script from "./CHeaderImg.vue?vue&type=script&lang=ts&"
export * from "./CHeaderImg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports